import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { RoutedOverlayChainContext } from "./RoutedOverlayChainContext";
import { getGlobalOverlayBasePath } from "./routedOverlayUtils";

/**
 * Base path for an overlay that can open from any page, such as a dialog launched from a
 * shared menu: the current pathname up to `segment`. Pass it as `basePath`.
 */
export const useGlobalOverlayBasePath = (segment: string): string =>
  getGlobalOverlayBasePath(useLocation().pathname, segment, {
    chain: useContext(RoutedOverlayChainContext),
  });
